/**
 * Test ID constants for data-testid attributes.
 *
 * Naming convention:  {BASE}-{PAGE}-{SECTION}-{ELEMENT}
 *   e.g. "setting-home-actions-export-label"
 *
 * All elements in this app share the same base prefix because the entire
 * application is a single module.
 */

// -- Base --------------------------------------------------------------------
/** Root prefix shared by every test ID in the application */
export const TEST_ID_BASE = 'setting' as const

// -- Pages -------------------------------------------------------------------
/** Page-level identifiers (second segment) */
export const TestIdPage = {
    HOME: 'home',
    SETTINGS: 'settings',
    PERSONAL_INFORMATION: 'personal-information',
    PROVINCIAL_TAX_RATE: 'provincial-tax-rate',
    SYSTEM_SETTINGS: 'system-settings',
    NAV: 'nav',
    TEMPLATES: 'templates',
    TEMPLATE_NEW: 'template-new',
    TEMPLATE_DETAIL: 'template-detail',
    NOT_FOUND: 'not-found',
    ACCESS_DENIED: 'access-denied',
    PIN_CODE: 'pin-code',
    TASK_TEMPLATES: 'task-templates',
    TASK_TEMPLATE_NEW: 'task-template-new',
    TASK_TEMPLATE_DETAIL: 'task-template-detail',
    INTEGRATION_LIST: 'integration-list',
    INTEGRATION_DETAIL: 'integration-detail',
    CUSTOMER_PORTAL_SETTINGS: 'customer-portal-settings',
    USER_SETTINGS: 'user-settings',
    COMMISSION_REPORTS_PASSWORD: 'commission-reports-password',
    FEATURE_MANAGEMENT: 'feature-management',
    FEATURE_CREATE_PROFILE: 'feature-create-profile',
    FEATURE_UPDATE_PROFILE: 'feature-update-profile',
    FEATURE_CONFIGURED_PROFILES: 'feature-configured-profiles',
    MARKETING_INFORMATION: 'marketing-information',
    GROSS_COMMISSION: 'gross-commission',
    MOPOLO_SETTINGS: 'mopolo-settings',
    MAILCHIMP: 'mailchimp',
    WEBSITE_SETTINGS: 'website-settings',
    ADMIN_WEBSITE_SETTINGS: 'admin-website-settings',
    CTP_PLATFORM_DEFAULTS: 'ctp-platform-defaults',
    CTP_PLATFORM_DOCUMENTS: 'ctp-platform-documents',
    CTP_PLATFORM_EMAILS: 'ctp-platform-emails',
    CTP_PLATFORM_NOTIFICATIONS: 'ctp-platform-notifications',
    BROKER_RATES: 'broker-rates',
    BRAND_RATES: 'brand-rates',
    NEW_PRESET_COMMISSION: 'new-preset-commission',
    ADMIN_PRESET_COMMISSION: 'admin-preset-commission',
    ADMIN_COMMISSION_VISIBILITY: 'admin-commission-visibility',
    ADMIN_PROGRAMS: 'admin-programs',
    CUSTOM_SIGNATURE: 'custom-signature',
    BROKER_PLATFORM_ANNOUNCEMENTS: 'broker-platform-announcements',
    BROKER_PLATFORM_BLOGS: 'broker-platform-blogs',
    BROKER_PLATFORM_MORTGAGE_SERVICES: 'broker-platform-mortgage-services',
    BROKER_PLATFORM_PRIVACY_POLICY: 'broker-platform-privacy-policy',
    BROKER_PLATFORM_TESTIMONIALS: 'broker-platform-testimonials',
    CORPORATE_CONTENT: 'corporate-content',
    LAND_TRANSFER_TAX: 'land-transfer-tax',
    AUTO_COMMUNICATION: 'auto-communication',
    DATA_TRANSFORMATION: 'data-transformation',
    DATA_IMPORT_SUMMARY: 'data-import-summary',
    DATA_IMPORT_SUMMARY_DETAIL: 'data-import-summary-detail',
    ADMIN_SIGNALR: 'admin-signalr',
    QA_TESTING: 'qa-testing',
    ERROR_MANAGEMENT: 'error-management',
    DEV_SERVICE_STATUS: 'dev-service-status',
    TRANSACTIONS_TO_REVIEW: 'transactions-to-review',
    TRANSACTION_TO_REVIEW_DETAIL: 'transaction-to-review-detail',
} as const

// -- Sections ----------------------------------------------------------------
/** Section-level identifiers (third segment) */
export const TestIdSection = {
    HEADER: 'header',
    SIDEBAR: 'sidebar',
    CONTENT: 'content',
    ACTIONS: 'actions',
    SEARCH: 'search',
    TABLE: 'table',
    FORM: 'form',
    MODAL: 'modal',
    PAGINATION: 'pagination',
    WIZARD: 'wizard',
    MAPPING: 'mapping',
} as const
